import { gql } from '@apollo/client';

import listingFields from '../fragments/listingFields';

const assetHistoriesQuery = gql`
  ${listingFields}
  query AssetHistories($graphId: String!, $skip: Int, $first: Int) {
    assetHistories(
      where: { asset: $graphId }
      orderBy: timestamp
      orderDirection: desc
      skip: $skip
      first: $first
    ) {
      id
      timestamp
      hash
      type
      bid {
        bidder {
          address
        }
        amount
        listing {
          ...ListingField
        }
      }
      listing {
        ...ListingField
        bids(orderBy: amount, orderDirection: desc) {
          id
          bidder {
            id
            address
          }
          amount
        }
      }
      sale {
        id
        amount
        auctionToken
        # isStarsPurchase
        buyer {
          id
          address
        }
        listing {
          ...ListingField
        }
      }
      transfer {
        from {
          address
        }
        to {
          address
        }
        quantity
      }
    }
  }
`;

export default assetHistoriesQuery;
